import { TabContext, TabList } from "@mui/lab";
import { Box, Card, CardMedia, Chip, Stack, Tab, Typography } from "@mui/material";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import { lightenHexColor } from "../../assets/helpers";
import Loader from "../../common/Loader";
import { FETCH_CLIENT_CATEGORIES, FETCH_CLIENT_VIDEOS, FETCH_CLIENT_VIDEOS_V2 } from "../../constant/Apipath";
import { ClientViewVideosModal } from "./ClientViewVideosModal";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";
import { useLocation } from "react-router-dom";
import TabsComponent from "../component/TabsComponent";
import InfiniteScroll from "react-infinite-scroll-component";

export default function ClientVideos() {
  const { selectedClientData, loginData, multiLanguageData } = useSelector((state) => state?.main);
  const [loading, setLoading] = useState(false);
  const [videosList, setVideosList] = useState([]);
  const [categoriesList, setCategoriesList] = useState([]);
  const [value, setValue] = useState(0);
  const [viewVideos, setViewVideos] = useState(false);
  const [currentVideo, setCurrentVideo] = useState(null);
  const location = useLocation();
  const [allDataLoaded, setAllDataLoaded] = useState(false);
  const [pageNr, setPageNr] = useState(1);
  //for multi language
  const LANGUAGE = ClientEnglishFallback?.ClientVideos(multiLanguageData?.ClientVideos || {});
  const { TEXT_NO_VIDEOS } = LANGUAGE;
  useEffect(() => {
    fetchVideosCategories();
  }, [location?.state?.searchText]);

  useEffect(() => {
    fetchVideos(1);
  }, [value, location?.state?.searchText]);

  const fetchVideosCategories = async () => {
    setLoading(true);
    try {
      let obj = {
        PageNr: 1,
        NrOfRecPerPage: 20,
        FullSearch: location?.state?.searchText || "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            clientEmployeeId: selectedClientData?.ClientEmployeeId,
            clientId: selectedClientData?.ClientId
          }
        ]
      };

      let res = await Postrequestcall(FETCH_CLIENT_CATEGORIES, obj, loginData?.accessToken);
      if (res?.status === 200) {
        setLoading(false);
        setCategoriesList([
          { translateLabel: "All", categoryName: "All", id: 0 },
          ...res?.data?.data
        ]);
      }
    } catch (error) {
      console.error("fetchVideosCategories-> Error Getting Categories: ", error);
      setLoading(false);
    }
  };

  const fetchVideos = async (pageNo) => {
    try {
      if (pageNo === 1) {
        setLoading(true);
      }
      setAllDataLoaded(true);
      let obj = {
        PageNr: pageNo,
        NrOfRecPerPage: 20,
        FullSearch: location?.state?.searchText || "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SortList: [{ FieldName: "Id", Direction: "DESC" }],
        SearchList: [
          {
            ...(value != 0 && { categoryId: value }),
            ClientId: selectedClientData?.ClientId,
            isActive: true
          }
        ]
      };

      let res = await Postrequestcall(FETCH_CLIENT_VIDEOS_V2, obj, loginData?.accessToken);
      let resData = res?.data?.data ?? [];
      if (res?.status === 200) {
        if (pageNo === 1) {
          setVideosList(resData);
        } else {
          setVideosList((prevData) => [...prevData, ...resData]);
        }
        setLoading(false);
        setAllDataLoaded(false);
      }
    } catch (error) {
      console.error("fetchVideos-> Error Fetching Client Videos: ", error);
      setLoading(false);
      setAllDataLoaded(false);
    }
  };

  const handleLoadMore = async () => {
    await fetchVideos(pageNr + 1);
    setPageNr((prevPage) => prevPage + 1);
  };

  // Utility to format duration
  const formatDuration = (duration) => {
    if (!duration) return "00:00";
    const parts = duration.split(":").map(Number);
    if (parts.length === 3) {
      // h:m:s
      const [h, m, s] = parts;
      if (h > 0) {
        return `${h.toString().padStart(2, "0")}:${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
      } else {
        return `${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
      }
    } else if (parts.length === 2) {
      // m:s
      const [m, s] = parts;
      return `${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
    } else if (parts.length === 1) {
      // s
      const [s] = parts;
      return `00:${s.toString().padStart(2, "0")}`;
    }
    return duration;
  };

  return (
    <>
      <TabsComponent
        setTabsValue={setValue}
        tabValue={value}
        tabs={categoriesList}
        label={"categoryName"}
        value={"id"}
        setPageNr={setPageNr}
      />

      <Stack
        gap={5}
        style={{ marginTop: "10px", height: "85vh", overflow: "auto" }}
        id="scrollablediv_prodcut">
        {loading ? (
          <Loader fullScreen />
        ) : (
          <>
            {videosList?.length == 0 ? (
              <>
                <Stack
                  sx={{
                    width: "100%",
                    height: "85vh",
                    justifyContent: "center",
                    alignItems: "center"
                  }}>
                  <Typography>{TEXT_NO_VIDEOS}</Typography>
                </Stack>
              </>
            ) : (
              <>
                <InfiniteScroll
                  dataLength={videosList?.length}
                  next={handleLoadMore}
                  hasMore={true}
                  loader={
                    !allDataLoaded ? null : (
                      <h4 style={{ display: "flex", justifyContent: "center" }}>
                        <Loader />
                      </h4>
                    )
                  }
                  scrollableTarget="scrollablediv_prodcut">
                  {videosList.map((video, index) => {
                    return (
                      <Card
                        onClick={() => {
                          setViewVideos(true);
                          setCurrentVideo(video);
                        }}
                        sx={{
                          cursor: "pointer",
                          padding: "10px",
                          boxShadow: "none",
                          borderRadius: "10px"
                        }}
                        key={index}>
                        <Stack sx={{ gap: 1 }} direction={"row"} >
                          <div
                            style={{
                              position: "relative"
                            }}>
                            <CardMedia
                              component="img"
                              width="250px"
                              height="150px"
                              alt="video"
                              sx={{
                                objectFit: "cover",
                                borderRadius: "5px",
                                border: "1px solid #E0E0E0",
                                height: {
                                  xs: "100px",
                                  sm: "100px",
                                  md: "150px",
                                  lg: "200px",
                                  xl: "200px"
                                },
                                width: {
                                  xs: "150px",
                                  sm: "150px",
                                  md: "250px",
                                  lg: "300px",
                                  xl: "300px"
                                }
                              }}
                              image={video?.thumbnail}
                            />
                            <Chip
                              sx={{
                                backgroundColor: "black",
                                color: "white",
                                borderRadius: "5px",
                                position: "absolute",
                                bottom: "10px",
                                right: "10px"
                              }}
                              size="small"
                              label={formatDuration(video?.duration)}
                            />
                          </div>
                          <Stack  sx={{ gap: 1, p: 1 }}>
                            <Typography sx={{ fontWeight: "bold" }} variant="h5">
                              {video?.title}
                            </Typography>
                            <Typography sx={{ color: "grey" }} variant="body2">
                              {dayjs(video?.dateCreated).format("MMMM DD, YY")}
                            </Typography>
                          </Stack>
                        </Stack>
                      </Card>
                    );
                  })}
                </InfiniteScroll>
              </>
            )}
          </>
        )}
      </Stack>
      {viewVideos && (
        <ClientViewVideosModal
          isOpen={viewVideos}
          onClose={() => {
            setViewVideos(false);
          }}
          data={currentVideo}
        />
      )}
    </>
  );
}

